export default "__VITE_ASSET__sKQDsR4r__"